import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-structured-holdings',
  templateUrl: './structured-holdings.component.html',
})
export class StructuredHoldingsComponent implements OnInit {
  iframeUrl!:string;
  showLocalSimon!:boolean;
  environment = environment;

  constructor() { }

  ngOnInit(): void {
    this.openSimonSso();
  }

  openSimonSso() {
    if (this.showLocalSimon) {
      this.iframeUrl = environment.simonLocalUrl;
    } else {
      this.iframeUrl = environment.simonUrl;
    }
    this.iframeUrl += '/lifecycle-portal/Clients';
  }

}
